import type { Participation } from "@tudigo-monorepo/core-tudigo-api-models";
import type { CollectionRequestParams } from "@tudigo-monorepo/web-tudigo-api-client";

import { ContentType, type Request, type TudigoResponse } from "../api";

export type GetUserParticipationsFilters = object | undefined; // TODO: add filters

export type GetUserParticipationsQueryParams = CollectionRequestParams<
  { userId: string },
  GetUserParticipationsFilters
>;

export const participationsEndpoints = (request: Request) => ({
  getUserParticipations: (queryParams?: GetUserParticipationsQueryParams) => {
    const { pathParams, ...query } = queryParams || {};

    return request<TudigoResponse<Participation[]>, void>({
      method: "GET",
      path: `/api/v1/users/${pathParams?.userId}/participation`,
      query: {
        fields: query.fields,
        ...query.filters,
        ...query.pagination,
        ...query.sorting,
      },
      secure: true,
      type: ContentType.Json,
    });
  },
});
